<script>
	import request from './request.vue';
	import Company from'./company.model.vue';
	import Article from'./article.model.vue';

	import { format } from "date-fns";

	let schema = [
		{
			name: "id",
			displayName: "Código",
			kind: "text",
			validation: "",
			defaultSort: true,
			readOnly: true,
			notInFilters: true,
		},
		{
			name: "user",
			displayName: "Mátricula",
			kind: "text",
			validation: "",
			defaultSort: true,
			readOnly: true,
			formatter: value => `${value.register || "Sem matrícula"}`,
		},
		{
			name: "userId",
			displayName: "Usuário",
			kind: "text",
			validation: "",
			defaultSort: true,
			readOnly: true,
		},
		{
			name: "user",
			displayName: "Usuário",
			kind: "text",
			validation: "",
			defaultSort: true,
			readOnly: true,
			formatter: value => `${value.name || "Sem nome"}`,
			search: {
				show: true,
				endWildcard: true,
				startWildcard: true,
			},
		},
		{
			name: "user",
			displayName: "Email",
			kind: "text",
			validation: "",
			defaultSort: true,
			readOnly: true,
			formatter: value => `${value.email || "Sem email"}`,
			notInFilters: true,
			search: {
				show: true,
				endWildcard: true,
				startWildcard: true,
			},
		},
		{
			name: "resultScore",
			displayName: "Resultado",
			kind: "text",
			validation: "required",
			readOnly: true,
			search: {
				show: true,
			},
		},
		{
			name: "result",
			displayName: "Mensagem",
			kind: "text",
			validation: "required",
			readOnly: true,
			notInFilters: true,
			formatter: value => `${value ? value.text.slice(0, 100) : ""}...`,
			search: {
				show: true,
			},
		},
		{
			name: "creationDate",
			displayName: "Data",
			kind: "text",
			validation: "",
			placeholder: "",
			readOnly: true,
			//formatter: value => format(new Date(value).toLocaleString("en-US", {timeZone: "America/sao_paulo"}), "DD/MM/YYYY HH:mm"),
			creationHidden: true,
			notInFilters: true,
			search: {
				show: true,
			},
		},
		{
			name: "articleId",
			displayName: "Módulo",
			kind: "text",
			validation: "",
			defaultSort: true,
			readOnly: true,
			search: {
				show: false,
			},
		},
		{
			name: "dateStart",
			displayName: "Data inicial",
			kind: "date",
			validation: "",
			defaultSort: true,
			readOnly: true,
			formatter: value => format(new Date(value).toLocaleString("en-US", {timeZone: "America/sao_paulo"}), "DD/MM/YYYY HH:mm"),
			creationHidden: true,
			notInResults: true,
			mask: "##/##/####",
			search: {
				show: true,
			},
		},
		{
			name: "dateEnd",
			displayName: "Data final",
			kind: "date",
			validation: "",
			defaultSort: true,
			readOnly: true,
			formatter: value => format(new Date(value).toLocaleString("en-US", {timeZone: "America/sao_paulo"}), "DD/MM/YYYY HH:mm"),
			creationHidden: true,
			notInResults: true,
			mask: "##/##/####",
			search: {
				show: true,
			},
		},
		
		{
			name: "platform",
			displayName: "Plataforma",
			kind: "select",
			validation: "",
			placeholder: "",
			readOnly: true,
			formatter: value => value ? value : "WEB",
			options: [
				{
					name: "WEB",
					value: "WEB",
				},
				{
					name: "APP",
					value: "APP",
				}
			],
			search: {
				show: true,
			}
		},
	];

	const creationSchema = [
		{
			name: "id",
			displayName: "Código",
			kind: "text",
			validation: "",
			defaultSort: true,
			readOnly: true,
			search: {
				show: false,
				endWildcard: true,
				startWildcard: true,
			},
		},
		{
			name: "minimumScore",
			displayName: "Pontuação mínima",
			kind: "text",
			validation: "required",
			search: {
				show: true,
			},
		},
		{
			name: "articleId",
			displayName: "Módulo",
			kind: "text",
			validation: "",
			defaultSort: true,
			readOnly: true,
			formatter: value => parseInt(value, 10),
			search: {
				show: false,
				endWildcard: true,
				startWildcard: true,
			},
		},
		{
			name: "levelDescription",
			displayName: "Nível",
			kind: "text",
			//validation: "required",
			search: {
				show: false,
			},
		},
		{
			name: "text",
			displayName: "Texto",
			kind: "html",
			validation: "required",
			search: {
				show: true,
			},
			editorId: "txtTestResultText",
			editorConfig: {
					plugins: "save emoticons image link media preview table textcolor autosave",
					toolbar: "save restoredraft | undo redo | styleselect bold italic forecolor backcolor | alignleft aligncenter alignright table | outdent indent | image link media | preview emoticons",
					statusbar: false,
			}
		},
		{
			name: "recommendation",
			displayName: "Recomendação",			
			kind: "html",			
			placeholder: "",
			editorId: "txtTestResultRecommendation",
			editorConfig: {
					plugins: "save emoticons image link media preview table textcolor autosave",
					toolbar: "save restoredraft | undo redo | styleselect bold italic forecolor backcolor | alignleft aligncenter alignright table | outdent indent | image link media | preview emoticons",
					statusbar: false,
			}
		},
		{
			name: "certificateUrl",
			displayName: "Certificado",
			kind: "file-url",
			//validation: "",
			placeholder: "",
			search: {
				show: false,
			},
			upload: async function (id, file) {
				const formData = new FormData();
				formData.append("file", file, file.name);
				let response = await request.sendFormData("testResult", `uploadCertificate/${id}`, formData);
				return response.data;
			},
		},
		{
			name: "idSAP",
			displayName: "IDSAP",			
			kind: "text",
			placeholder: "",
		},
	];


	export default {
		getSchema: function() {
			schema = schema.filter(function( obj ) {
					return obj.displayName !== 'Empresa' && obj.displayName !== 'Módulo';
			});

			Company.getAll().then((companies) => {
				
				schema.push({
					name: "company",
					displayName: "Empresa",
					kind: "select",
					validation: "",
					defaultSort: true,
					readOnly: true,
					options: companies.map(company => ({
						name: company.name,
						value: company.id,
					})),
					formatter: value => `${value ? value.name : "Sem companhia"}`,
					search: {
						show: true,
					},
				})
			})
			.catch((err) => console.log(err));
		
			Article.getAll()
				.then((articles) => {
					const currentArticle = articles.filter(item => item.name === "Avaliação Emocional");
					schema.push({
						name: "article",
						displayName: "Módulo",
						kind: "select",
						currentValue: currentArticle[0] != null ? currentArticle[0].name: "",
						validation: "",
						defaultSort: true,
						readOnly: true,
						options: articles.map(article => ({
							name: article.name,
							value: article.name,
						})),
						formatter: value => `${value.name}`,
						search: {
							show: true,
							endWildcard: true,
							startWildcard: true,
						},
					})
				})
				.catch((err) => console.log(err));

			return schema;
		},
		getCreateSchema: function () {
			return creationSchema;
		},
		create: async function (entity) {
			const response = await request.send("testResult", "create", entity, true);
			return response.data;
		},
		getInfo: async function (id) {
			const response = await request.send("testResult", "read", { id }, true);
			return response.data;
		},
		read: async function (id) {
			const response = await request.send("userTestResult", "read", { id }, true);
			return response.data;
		},
		updateInfo: async function (info) {
			const response = await request.send("testResult", "update", info, true);
			return response.data;
		},
		search: async function(parameters) {
			if (parameters.dateStart) parameters.dateStart = parameters.dateStart.split("/").reverse().join("-");
			if (parameters.dateEnd) parameters.dateEnd = parameters.dateEnd.split("/").reverse().join("-");

			parameters.orderBy = "creationDate";
			parameters.orderDirection = "desc";

			console.log(parameters);
			const response = await request.send("userTestResult", "search", parameters, true);
			console.log(response);
			return response;
		},
		getTestResult: async function(parameters) {
			const response = await request.send("testResult", "findByScore", parameters, true);
			return response.data;
		},
		searchEntity: async function(parameters) {
			console.log(parameters);
			return request.send("testResult", "search", parameters, true);
		},
		download: async function(parameters) {
			if (parameters.dateStart) parameters.dateStart = parameters.dateStart.split("/").reverse().join("-");
			if (parameters.dateEnd) parameters.dateEnd = parameters.dateEnd.split("/").reverse().join("-");

			parameters.download = true;

			const response = await request.send("userTestResult", "search", parameters, true);
			return response;
		}
	}
</script>
